import React from 'react';
import styled from 'styled-components';
import SunshineCoin from './SunshineCoin';

const InlineSunshineCoin = ({ color }: { color?: string }) => {
  return <Wrapper>
    <SunshineCoin title="Sunshine Coin" color={color}/>
  </Wrapper>;
};

const Wrapper = styled.span`
  svg {
    position: relative;
    width: 1em;
    height: 1em;
    top: .1em;
  }
`;

export default InlineSunshineCoin;
